import { PointCloudCommandManager } from '@pointorama/pointcloud-commander';
import { createContext } from 'react';

export type CommandManagerContextType = { commander: PointCloudCommandManager };
// @ts-ignore
export const CommandManagerContext = createContext<CommandManagerContextType>({});
